module.exports = __webpack_public_path__ + "fcf03b9d231a7a6d196fac2dd833244e.png";